import React, {Fragment, useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import {handleValidateObj} from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import {Button, Image} from "react-bootstrap";
import Images from "../../../assets/images/imageData";
import propTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { toast, ToastContainer } from "react-toastify";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import CardSection from 'components/sales/cardSection/cardSection';
import {saveEmpMrfSerialNo} from "../../../services/redux/MaterialRequistionForm/action";

const EmpFullfillmentForm = ({
                        history,
                        match,
                        viewEmpMrfMaterial,
                        materialData,
                        saveEmpMrfSerialNo
                      }) => {

  const [inputList, setInputList] = useState([{id: "",material_code: "", quantity: "", serial_number: []}]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalMsg,setMessage] = useState('');
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    if (
      materialData?.material_acquisition_line_items !== undefined &&
      materialData?.material_acquisition_line_items !== null
    ) {
      const matData = materialData?.material_acquisition_line_items;

      setTimeout(() => {
        if (matData != '') {
          setInputList(matData);
        }
      }, 100);

    }
  }, [materialData]);

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      viewEmpMrfMaterial(match.params.id);
      setIsLoading(false)
    })()
  }, [viewEmpMrfMaterial]);

  const handledropDownChange = (e, index, name) => {
    const list = [...inputList];
    list[index][name] = e;
    setInputList(list);
  };

  const handleModalHide = async () => {
    setIsModal(false);
    history.push(`${baseUrl}/employee-mrf`);
  };

  const handleSubmit = (id) => {
    // console.log(inputList);return;
    (async () => {
      setIsLoading(true);
      var obj = {mrf_data: inputList,
        mrf_id: id
      };
      const res = await saveEmpMrfSerialNo(obj);
      if (res) {
        setMessage('Details saved successfully!');
        setIsModal(true);
      }
      setIsLoading(false);
    })();
  };

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(match.params.id)} /* disabled={isClicked} */>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight}/>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      title={localization.goBack}
    >
      <FormSection title={localization.empMrf} status='Created' headerData={'Requested by: ' + materialData?.employee_type?.name}>

        {inputList.map((x, i) => {
          return (
            <CardSection title={x?.materials?.material_name}>
              <div key={i} className="row">
                <div className="col-md-3">
                  <ConstantInput
                    label={'Quantity'}
                    value={x.quantity}
                    disabled={true}
                  />
                </div>
                  <div className="col-md-3">
                    <DropDownInput
                      label={localization.serialNo}
                      data={(x?.serial_no && x?.serial_no !== null) ? x?.serial_no : []}
                      getIdValue={(val) => {
                          handledropDownChange(val, i, 'serial_number');
                        }
                      }
                      multipule
                      // value={x.status}
                    />
                  </div>
              </div>
            </CardSection>
          );
        })}
      </FormSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{modalMsg}</h5>
          <Link
            to={`${baseUrl}/employee-mrf`}
            className="btn btn-primary mb-4"
          >
            Go to Listing <img src={Images?.ArrowRight} alt="" />
          </Link>

        </div>
      </ModalPop>

    </Layout>
  );
};
EmpFullfillmentForm.propTypes = {
  data: PropTypes.any,
  history: propTypes.any,
};
export default EmpFullfillmentForm;
